export default {"src":"/_next/static/media/discord.d3abd35d.svg","height":55,"width":239};